var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-list",
    { staticClass: "filters", staticStyle: { "max-width": "711px" } },
    [
      _c(
        "v-layout",
        { staticClass: "pa-5s", attrs: { row: "" } },
        [
          _c(
            "v-flex",
            {
              staticStyle: { "margin-left": "-5px" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _c("v-select", {
                staticClass: "v-select__form mb-35p",
                staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                attrs: {
                  items: _vm.productsType,
                  label: "Tipo de producto",
                  "append-icon": "icon-ic-expand-more",
                  placeholder: "Todos los tipos de productos"
                },
                on: { change: _vm.selectProductType },
                model: {
                  value: _vm.productType,
                  callback: function($$v) {
                    _vm.productType = $$v
                  },
                  expression: "productType"
                }
              }),
              _c("v-select", {
                staticClass: "v-select__form mb-3",
                staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                attrs: {
                  items: _vm.products,
                  label: "Producto",
                  "append-icon": "icon-ic-expand-more",
                  placeholder: "Todos los productos"
                },
                on: { change: _vm.selectIdProduct },
                model: {
                  value: _vm.product,
                  callback: function($$v) {
                    _vm.product = $$v
                  },
                  expression: "product"
                }
              }),
              _c("date-option", {
                ref: "dateOptionAdmin",
                attrs: { labelDateOption: "Fecha de ingreso" },
                on: { input: _vm.dateOptionSelected, click: _vm.dateAdmin }
              }),
              _c("date-option", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.conditional,
                    expression: "conditional"
                  }
                ],
                ref: "dateOptionHight",
                attrs: { labelDateOption: "Fecha Alta" },
                on: { input: _vm.dateOptionSelected, click: _vm.dateHight }
              }),
              _c("v-select", {
                staticClass: "v-select__form mb-35p",
                staticStyle: {
                  border: "1px solid rgba(202,203,205,0.5)",
                  "margin-top": "35px"
                },
                attrs: {
                  items: _vm.typeOfSolutions,
                  label: "Estado de solicitud",
                  "append-icon": "icon-ic-expand-more",
                  placeholder: "Tipo de solución"
                },
                on: { change: _vm.selectTypeofSolution },
                model: {
                  value: _vm.typeOfSolution,
                  callback: function($$v) {
                    _vm.typeOfSolution = $$v
                  },
                  expression: "typeOfSolution"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { staticStyle: { "margin-left": "25px" } },
            [
              _c("v-select", {
                staticClass: "v-select__form mb-35p",
                staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                attrs: {
                  items: _vm.departments,
                  label: "Departamento",
                  "append-icon": "icon-ic-expand-more",
                  placeholder: "Todos los departamentos"
                },
                on: { change: _vm.selectDepartment },
                model: {
                  value: _vm.department,
                  callback: function($$v) {
                    _vm.department = $$v
                  },
                  expression: "department"
                }
              }),
              _c("v-select", {
                staticClass: "v-select__form mb-35p",
                staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                attrs: {
                  items: _vm.provinces,
                  label: "Provincia",
                  "append-icon": "icon-ic-expand-more",
                  placeholder: "Todas las provincias"
                },
                on: { change: _vm.selectProvince },
                model: {
                  value: _vm.province,
                  callback: function($$v) {
                    _vm.province = $$v
                  },
                  expression: "province"
                }
              }),
              _c("v-select", {
                staticClass: "v-select__form mb-35p",
                staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                attrs: {
                  items: _vm.districts,
                  label: "Distrito",
                  "append-icon": "icon-ic-expand-more",
                  placeholder: "Todos los distritos"
                },
                on: { change: _vm.selectDistrict },
                model: {
                  value: _vm.district,
                  callback: function($$v) {
                    _vm.district = $$v
                  },
                  expression: "district"
                }
              }),
              _vm.isInProcess
                ? _c("v-text-field", {
                    staticClass: "style-stepped",
                    staticStyle: { "margin-right": "1px" },
                    attrs: {
                      label: "Estado",
                      type: "text",
                      name: "status",
                      placeholder: _vm.affiliationsStatus,
                      disabled: ""
                    },
                    model: {
                      value: _vm.status,
                      callback: function($$v) {
                        _vm.status = $$v
                      },
                      expression: "status"
                    }
                  })
                : _c("v-select", {
                    staticClass: "v-select__form mb-35p",
                    staticStyle: { border: "1px solid rgba(202,203,205,0.5)" },
                    attrs: {
                      items: _vm.statusItems,
                      label: "Estado",
                      "append-icon": "icon-ic-expand-more"
                    },
                    model: {
                      value: _vm.status,
                      callback: function($$v) {
                        _vm.status = $$v
                      },
                      expression: "status"
                    }
                  }),
              _c(
                "v-flex",
                {
                  staticClass: "d-flex",
                  staticStyle: { "margin-top": "37px" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-filters ma-0",
                      staticStyle: { color: "#7E868B" },
                      attrs: { flat: "" },
                      on: { click: _vm.clearFilters }
                    },
                    [_vm._v("Limpiar filtros")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-filters bg-blue-style ma-0",
                      staticStyle: { width: "180px" },
                      on: { click: _vm.onSubmit }
                    },
                    [_vm._v("Aplicar filtros")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c49061a2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c49061a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/btn-filters.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-c49061a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/btn-filters.vue
// module chunks = 0 5